// @flow

import React from "react";
import { type FieldRenderProps } from "react-final-form";
import FieldControl, { type FieldControlProps } from "../FieldControl";
import TextInput from "../Input/TextInput";
import PercentageInput from "../Input/PercentageInput";
import AreaInput from "../Input/AreaInput";
import TextArea from "../TextArea";
import NumberInput from "../Input/NumberInput";
import RadioGroup, { type Options } from "../RadioGroup";
import YesNoRadioGroup from "../YesNoRadioGroup";
import Select, { type SelectOption } from "../Select";
import DatePicker from "../DatePickers/DatePicker";
import MonthPicker from "../DatePickers/MonthPicker";
import YearPicker from "../DatePickers/YearPicker";
import TagList from "../Select/TagList";
import FormContext from "../../utils/form-context";

import styles from "./EditableField.scss";

type EditableFieldProps = {
  type: string,
  displayValue: (value: any, options: Array<Options | SelectOption>) => string,
  inputProps: any,
  fieldControlProps: FieldControlProps
};

const inputTypes = {
  textInput: TextInput,
  textArea: TextArea,
  radioGroup: RadioGroup,
  yesNoGroup: YesNoRadioGroup,
  select: Select,
  datePicker: DatePicker,
  numberInput: NumberInput,
  monthPicker: MonthPicker,
  percentageInput: PercentageInput,
  areaInput: AreaInput,
  yearPicker: YearPicker,
  tagList: TagList
};

const EditableField = ({
  type,
  displayValue,
  inputProps,
  fieldControlProps
}: EditableFieldProps) => {
  let InputType = null;
  InputType = inputTypes[type];

  return (
    <FormContext.Consumer>
      {({ isEditMode }) => (
        <FieldControl
          {...fieldControlProps}
          isOptional={isEditMode && fieldControlProps.isOptional}
        >
          {({ input }: FieldRenderProps) =>
            isEditMode && InputType ? (
              <InputType input={input} {...inputProps} />
            ) : (
              <span className={styles.dumbValue}>
                {!input.value && typeof input.value !== "boolean"
                  ? "-"
                  : displayValue(input.value, inputProps.options)}
              </span>
            )
          }
        </FieldControl>
      )}
    </FormContext.Consumer>
  );
};

EditableField.defaultProps = {
  isEditMode: false,
  type: null,
  displayValue: val => val,
  inputProps: {}
};

export default EditableField;
